// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * BoardAttributes type.
 * @typedef {object} BoardAttributes
 * @property {Date} createdAt - Attribute value.
 * @property {string} id - Attribute value.
 * @property {string} name - Attribute value.
 * @property {string} projectId - Attribute value.
 * @property {Date} updatedAt - Attribute value.
 */
/**
 * Attributes accepted by BoardCreateAttributes.
 * @typedef {object} BoardCreateAttributes
 * @property {BoardAttributes["name"] | null} [name] - Permitted name value.
 * @property {BoardAttributes["projectId"] | null} [projectId] - Permitted projectId value.
 */
/**
 * Attributes accepted by BoardUpdateAttributes.
 * @typedef {object} BoardUpdateAttributes
 * @property {BoardAttributes["name"] | null} [name] - Permitted name value.
 * @property {BoardAttributes["projectId"] | null} [projectId] - Permitted projectId value.
 */
/**
 * Frontend model for Board.
 * @augments {FrontendModelBase<BoardAttributes, BoardCreateAttributes, BoardUpdateAttributes, BoardAttributes["id"], string>}
 */
class Board extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "Board",
      attributes: [
        "createdAt",
        "id",
        "name",
        "projectId",
        "updatedAt",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      boardColumns: {type: "hasMany"},
      project: {type: "belongsTo"},
      taskBoards: {type: "hasMany"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      boardColumns: "BoardColumn",
      project: "Project",
      taskBoards: "TaskBoard",
    }
  }

  /** @returns {BoardAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {BoardAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string} newValue - New attribute value.
   * @returns {Date | string} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {BoardAttributes["id"]} - Attribute value. */
  id() { return /** @type {BoardAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {BoardAttributes["id"] | null} newValue - New attribute value.
   * @returns {BoardAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {BoardAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {BoardAttributes["name"]} - Attribute value. */
  name() { return /** @type {BoardAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {BoardAttributes["name"] | null} newValue - New attribute value.
   * @returns {BoardAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {BoardAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /** @returns {BoardAttributes["projectId"]} - Attribute value. */
  projectId() { return /** @type {BoardAttributes["projectId"]} */ (this.readAttribute("projectId")) }

  /**
   * @param {BoardAttributes["projectId"] | null} newValue - New attribute value.
   * @returns {BoardAttributes["projectId"] | null} - Assigned value.
   */
  setProjectId(newValue) { return /** @type {BoardAttributes["projectId"] | null} */ (this.setAttribute("projectId", newValue)) }

  /** @returns {BoardAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {BoardAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string} newValue - New attribute value.
   * @returns {Date | string} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string} */ (this.setAttribute("updatedAt", newValue)) }

  /**
   * Returns boardColumns relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Board, import("./board-column.js").BoardColumn, import("./board-column.js").BoardColumnCreateAttributes>} - Relationship helper.
   */
  boardColumnsRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Board, import("./board-column.js").BoardColumn, import("./board-column.js").BoardColumnCreateAttributes>} */ (this.getRelationshipByName("boardColumns")) }

  /**
   * Returns boardColumns.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Board, import("./board-column.js").BoardColumn, import("./board-column.js").BoardColumnCreateAttributes>} - Relationship helper.
   */
  boardColumns() { return this.boardColumnsRelationship() }

  /**
   * Returns loaded boardColumns.
   * @returns {Array<import("./board-column.js").BoardColumn>} - Loaded related models.
   */
  boardColumnsLoaded() { return this.boardColumnsRelationship().loaded() }

  /**
   * Loads boardColumns.
   * @returns {Promise<Array<import("./board-column.js").BoardColumn>>} - Loaded related models.
   */
  async loadBoardColumns() { return await this.boardColumnsRelationship().load() }

  /**
   * Returns project relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Board, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} - Relationship helper.
   */
  projectRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Board, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} */ (this.getRelationshipByName("project")) }

  /**
   * Returns project.
   * @returns {import("./project.js").Project | null} - Loaded related model.
   */
  project() { return this.projectRelationship().loaded() }

  /**
   * Builds project.
   * @param {import("./project.js").ProjectCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./project.js").Project} - Built related model.
   */
  buildProject(attributes = {}) { return this.projectRelationship().build(attributes) }

  /**
   * Loads project.
   * @returns {Promise<import("./project.js").Project | null>} - Loaded related model.
   */
  async loadProject() { return await this.projectRelationship().load() }

  /**
   * Returns or loads project.
   * @returns {Promise<import("./project.js").Project | null>} - Loaded related model.
   */
  async projectOrLoad() { return await this.projectRelationship().orLoad() }

  /**
   * Sets project.
   * @param {import("./project.js").Project | null} model - Related model.
   * @returns {void}
   */
  setProject(model) { this.projectRelationship().setLoaded(model) }

  /**
   * Returns taskBoards relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Board, import("./task-board.js").TaskBoard, import("./task-board.js").TaskBoardCreateAttributes>} - Relationship helper.
   */
  taskBoardsRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Board, import("./task-board.js").TaskBoard, import("./task-board.js").TaskBoardCreateAttributes>} */ (this.getRelationshipByName("taskBoards")) }

  /**
   * Returns taskBoards.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Board, import("./task-board.js").TaskBoard, import("./task-board.js").TaskBoardCreateAttributes>} - Relationship helper.
   */
  taskBoards() { return this.taskBoardsRelationship() }

  /**
   * Returns loaded taskBoards.
   * @returns {Array<import("./task-board.js").TaskBoard>} - Loaded related models.
   */
  taskBoardsLoaded() { return this.taskBoardsRelationship().loaded() }

  /**
   * Loads taskBoards.
   * @returns {Promise<Array<import("./task-board.js").TaskBoard>>} - Loaded related models.
   */
  async loadTaskBoards() { return await this.taskBoardsRelationship().load() }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(Board)

export {Board}

export default Board
